// extracted by mini-css-extract-plugin
module.exports = {"basic":"SetPage_basic__1W1DS","tax":"SetPage_tax__1fEH_"};